import styled from 'styled-components';

export const CurrentConditionIconWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 93px;
    & .wb-content-mgt-icon-image {
        width: 90px;
        height: 90px;
    }
`;
